module.exports = __webpack_public_path__ + "img/34.3b916428.png";